<template>
  <div class="relative">
    <form @submit.prevent="search">
      <input
        v-model="searchText"
        type="text"
        class="h-9 rounded-md bg-white bg-opacity-30 px-3 font-medium text-placeholder-gray placeholder-placeholder-gray outline-none"
        :class="`${wAuto.length > 0 ? wAuto : 'w-72'}`"
        style="font-size: 11px"
        placeholder="Type broker name, DOT #, Docket #"
      />
      <button
        type="submit"
        class="absolute bottom-0 right-0 top-0 flex w-8 flex-col justify-center bg-transparent text-placeholder-gray hover:text-yellow-500"
      >
        <!-- inline search-icon.svg -->
        <svg
          width="17"
          height="18"
          viewBox="0 0 17 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.7893 12.7305L16.2692 17.2104"
            stroke="currentColor"
            stroke-width="2"
          />
          <circle
            cx="7.9493"
            cy="8.25118"
            r="6.67989"
            stroke="currentColor"
            stroke-width="2"
          />
        </svg>
        <!-- END inline search-icon.svg -->
      </button>
    </form>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';

export default {
  name: 'SearchBar',
  props: {
    wAuto: {
      type: String,
      default: '',
    },
  },
  setup: () => {
    const router = useRouter();
    const searchText = ref('');

    const search = () => {
      goToSearchCarriers();
    };

    onMounted(() => {
      searchText.value = router.currentRoute.value.query.q || '';
    });

    const goToSearchCarriers = () => {
      if (searchText.value === '') {
        return;
      }
      router.push({
        name: 'Carrier Brokers Search Results',
        query: {
          q: searchText.value,
        },
      });
    };

    return {
      search,
      searchText,
      goToSearchCarriers,
    };
  },
};
</script>
